import { useActivityConstants } from "@/apps/tatar/activityApp/ActivityHooks";
import { APActivity } from "@/apps/tatar/activityApp/ActivityInterfaces";
import { APOffer } from "@/apps/tatar/activityApp/views/details/offer-feature/APOffer.Interface";
import ModalManager from "@/components/ModalComponent/ModalManager";
import { useAsyncAction } from "@/hooks/useAsyncAction";
import i18n from "@/i18n";
import BFButton from "@/modules/abstract-ui/general/Button/BFButton";
import PermissionService from "@/services/PermissionService";
import VacancyContractUtils from "../../../../vacancy-applicant/utils/VacancyContractUtils";
import VacancyContractSignChangeForm from "./VacancyContractSignChangeForm";
import useVacancyContractDetailsActions from "../useVacancyContractDetailsActions";

type Props = {
  activity: APActivity;
  offer: APOffer;
  reload?: () => void;
};

const VacancyContractSignChangeButton = (props: Props) => {
  const { activity, offer, reload } = props;
  const constants = useActivityConstants();
  const { digitalRentalAgreementSigners } = useVacancyContractDetailsActions();

  const changeSignerFunc = async (signerId: string, reason: string) => {
    const onBehalfOf =
      constants?.fields?.vacancyApplicationApproval
        ?.digitalContractOnBehalfOf || "";

    const success = await VacancyContractUtils.changeDigitalContractSigner(
      offer,
      signerId,
      onBehalfOf,
      reason
    );

    if (success && reload) {
      reload();
    }
  };

  const { execute: changeSigner, loading } = useAsyncAction({
    asyncFn: changeSignerFunc,
  });

  const businessUnitRoles =
    PermissionService.hasBusinessUnitRole(
      constants?.permissionPrefix + "overwriteDigitalContractSigner",
      true
    ) || [];

  const hasPermission = businessUnitRoles.includes(activity.data.type);

  if (!hasPermission) {
    return null;
  }

  const onChangeSignerClick = () => {
    ModalManager.show({
      noPadding: true,
      closable: true,
      content: (
        _states: any,
        _setStates: (states: any) => void,
        closeModal?: () => void
      ) => (
        <VacancyContractSignChangeForm
          changeSigner={(signerId: string, reason: string) => {
            changeSigner(signerId, reason);
          }}
          signerIds={digitalRentalAgreementSigners.map((s) => s.userId)}
          onClose={closeModal}
        />
      ),
    });
  };

  return (
    <div>
      <BFButton
        appearance="link"
        onClick={onChangeSignerClick}
        loading={loading}
      >
        {i18n.t(
          "apTemplate:Vacancy.Applicant.ContractDetails.Label.OfferAccepted.ChangeSigner",
          "Anderen Unterzeichner eintragen"
        )}
      </BFButton>
    </div>
  );
};

export default VacancyContractSignChangeButton;
